import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import { Image } from 'antd'
import Icon1 from '../../../assets/mobile-app/manage-account-icon1.png'
import Icon2 from '../../../assets/mobile-app/manage-account-icon2.png'
import Icon3 from '../../../assets/mobile-app/manage-account-icon3.png'
import { useTranslation } from 'react-i18next'
import ManageBanner from '../../../assets/mobile-app/manage-account-banner.png'

export const SMAppManageAccount: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'icon': Icon1,
            'title': t('t278'),
            'content': t('t279'),
        },
        {
            'icon': Icon2,
            'title': t('t280'),
            'content': t('t281'),
        },
        {
            'icon': Icon3,
            'title': t('t282'),
            'content': t('t283'),
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Grid item key={index} xs={12}>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    <Image src={data[index]['icon']} width={70} height={70} alt='' preview={false}></Image>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'} paddingTop={'16px'}>
                        {data[index]['title']}
                    </Typography>
                    <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'} paddingTop={'10px'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingBottom: '30px',
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                paddingTop: '60px',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Image src={ManageBanner} style={{borderRadius: '10px'}} alt='' preview={false}></Image>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    paddingTop: '30px',
                }}>
                    <Typography fontSize={24} fontWeight={700} color={'#141F39'}>
                        {t('t276')}
                    </Typography>

                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'16px'}>
                        {t('t277')}
                    </Typography>

                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        paddingTop: '36px',
                    }}>
                        <Grid container rowSpacing={3}>
                            {data.map((item, index) => (
                                renderItem(index)
                            ))}
                        </Grid>
                    </Box>

                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMAppManageAccount
